
// config.ts

const NEXT_PUBLIC_BASE_URL = 'https://personal-study-coach-backend-644532896968.us-central1.run.app';
// const NEXT_PUBLIC_BASE_URL = 'http://0.0.0.0:8000';

export const NEXT_PUBLIC_GOOGLE_CLIENT_ID = "644532896968-248pjabbk6nq18lacl5tta1mqlg631dr.apps.googleusercontent.com";

export default NEXT_PUBLIC_BASE_URL;
